import Flex from '@components/Flex/Flex';
import { Box, styled } from '@mui/material';

export const StyledBoxContainer = styled(Box)<{ image: string | undefined }>(
  ({ theme, image }) => ({
    display: 'flex',
    flex: 1,
    padding: theme.spacing(10),
    backgroundImage: `url("${image}")`,
    height: '257px',
    backgroundSize: 'cover',
    color: theme.palette.common.white,
    borderRadius: theme.spacing(5),
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      height: '187px',
    },
  })
);

export const Logo = styled('img')(({ theme }) => ({
  width: '137px',
  height: '40px',
  objectFit: 'cover',
}));

export const LogoTitleContainer = styled(Flex)(({ theme }) => ({
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flexDirection: 'column',
  flex: 1,
  [theme.breakpoints.down('md')]: {
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
}));

export const FlexPlaceholdersContainer = styled(Flex)(({ theme }) => ({
  flex: 2.7,
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  display: 'flex',
  gap: theme.spacing(16),
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
  [theme.breakpoints.down(950)]: {
    flex: 1,
  }
}));

export const FlexPlaceholder = styled(Flex)(({ theme }) => ({
  height: 220,
  width: 225,
}));
